<template>
  <div
    :style="{
      backgroundColor: isTermination ? PaletteColors['danger-lighten-80'] : PaletteColors['default'],
      color: isTermination ? PaletteColors['danger-darken-10'] : PaletteColors['base-white'],
    }"
    class="reason"
  >
    {{ getReasonLabel(props.reasonOptions, props.reason) }}
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { PaletteColors } from '@/Theme';
import { getReasonLabel, isTerminationReason } from '@/pages/one-time-payments/utils';

const props = defineProps({
  reason: {
    type: String,
    required: true,
  },
  reasonOptions: {
    type: Array,
    required: true,
  },
});

const isTermination = computed(() => isTerminationReason(props.reasonOptions, props.reason));
</script>

<style scoped>
.reason {
  text-transform: capitalize;
  width: fit-content;
  padding: 0.15rem 0.5rem;
  border-radius: 4rem;
  font-weight: 500;
  text-align: right;
}
</style>
